import React from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect } from "react";
import products from "../data/product";
import slugify from "../utils/slugify";
import { Link } from "react-router-dom";
import CategoryHero from "../components/CategoryHero";

const categoryMap = {
    insecticides: "Insecticide",
    fungicides: "Fungicide",
    herbicides: "Herbicide",
    fertilizers: "Fertilizer",
    "plant-growth-regulators": "Plant Growth Regulator",
    "NPK-Fertilizer": "NPK Fertilizer",
};

const CategoryProducts = () => {

    const { categorySlug } = useParams();

    const categoryName = categoryMap[categorySlug];

    const filteredProducts = products.filter(
        (p) => p.category === categoryName
    );

    return (
        <>
            {/* HERO */}
            <CategoryHero categorySlug={categorySlug} />

            {/* PRODUCTS */}
            <section className="section" style={{ background: "#000000" }}>
                <Container>

                    <div className="section-title">
                        <h2>{categoryName}</h2>
                        <p>
                            {filteredProducts.length} trusted products available in this
                            category.
                        </p>
                    </div>

                    <Row>
                        {filteredProducts.map((item) => (
                            <Col lg={3} md={4} sm={6} className="mb-4" key={item.id}>
                                <div className="product-card">

                                    <img
                                        src={item.image}
                                        alt={item.productName}
                                        style={{
                                            width: "100%",
                                            height: "220px",
                                            objectFit: "cover",
                                        }}
                                    />

                                    <div className="product-overlay">
                                        <Link
                                            to={`/product/${slugify(item.productName)}`}
                                            className="product-btn"
                                        >
                                            View Details
                                        </Link>
                                    </div>

                                </div>
                            </Col>
                        ))}
                    </Row>

                    {filteredProducts.length === 0 && (
                        <p style={{ color: "#fff" }}>No products found.</p>
                    )}

                </Container>
            </section>
        </>
    );
};

export default CategoryProducts;
